export default "__VITE_ASSET__WHtM$UFu__"